export function InternalError() {
  return (
    <div className="d-flex flex-column align-items-center text-center p-3 ">
      <img
        src="/svgs/internal-error.svg"
        alt="Logo Alerta Rolante"
        style={{ width: '24rem' }}
        className="mb-5"
      />
      <span className="title">
        Ocorreu um erro inesperado. <br />
        Por favor, tente novamente mais tarde.
      </span>
    </div>
  );
}
